import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Container,
  Paper,
  Grid,
  IconButton,
  Stack,
  Typography,
  Button,
  Checkbox,
  Box,
  Menu,
  MenuItem,
  useMediaQuery,
  Tooltip,
  Avatar,
  Badge,
  TextField,
} from "@mui/material";
import { get_zone_date, isColorLight, replacedText } from "src/utils";
import {
  LabelPopup,
  MuiDialog,
  PriorityPopover,
  StatusPopover,
  TaskCreatedAt,
  TaskDatePick,
  TaskDatePicker,
  TeamMembers,
  TeamPicker,
  UserAvatar,
} from "..";
import Iconify from "../Iconify";
import Label from "../Label";
import { useAppContext } from "src/hooks";
import { format, parseISO } from "date-fns";
import { _project_team, _update_time_track } from "src/DAL";
import { useSnackbar } from "notistack";
import { useLocation, useNavigate } from "react-router-dom";
import { s3baseUrl } from "src/config";
import moment from "moment";
import TaskStartedBy from "./TaskStartedBy";
import IssueReport from "./IssueReport";
import Feedback from "./FeedBack";
// ---------------------------------------------------------

const stack_props = {
  direction: "row",
  alignItems: "center",
  columnGap: 0.5,
};
const icon_color = "#637381";
const menu_item_icon_size = { height: "1rem", width: "1rem" };
// ---------------------------------------------------------
const TaskCard = ({
  task,
  variant,
  projectTeam,
  onOpenDetail,
  onOpenComments,
  onTaskAction,
  taskSection,
  onSetSelectedTask,
  projectSections,
  isDraggingOver,
  currentUserRole,
  taskTeam,
  projectTags,
  setProjectTags,
  onChangeTags,
  sections,
  getFilteredTasksBySection,
  loadingMember = {},
}) => {
  // ---------------------------------------------------------
  const { dispatch_get_user_profile } = useAppContext();
  const userProfile = dispatch_get_user_profile();

  if (variant === "default") {
    return (
      <DefaultVariant
        onSetSelectedTask={(task) => onSetSelectedTask(task)}
        onOpenComments={onOpenComments}
        onOpenDetail={onOpenDetail}
        projectTeam={projectTeam}
        task={task}
        taskSection={taskSection}
        onTaskAction={(action, data) => onTaskAction(action, data)}
        projectSections={projectSections}
        isDraggingOver={isDraggingOver}
        userProfile={userProfile}
        currentUserRole={currentUserRole}
        setProjectTags={setProjectTags}
        projectTags={projectTags}
        onChangeTags={onChangeTags}
        sections={sections}
        getFilteredTasksBySection={getFilteredTasksBySection}
        loadingMember={loadingMember}
      />
    );
  }
  if (variant === "disabled") {
    return (
      <DisabledVariant
        currentUserRole={currentUserRole}
        userProfile={userProfile}
        onSetSelectedTask={(task) => onSetSelectedTask(task)}
        onOpenComments={onOpenComments}
        onOpenDetail={onOpenDetail}
        projectTeam={projectTeam}
        task={task}
        taskSection={taskSection}
        onTaskAction={(action, data) => onTaskAction(action, data)}
        loadingMember={loadingMember}
      />
    );
  }
  if (variant === "dashboard") {
    return (
      <DashboardVariant
        onOpenDetail={onOpenDetail}
        task={task}
        onTaskAction={(action, data) => onTaskAction(action, data)}
      />
    );
  }
  if (variant === "allTasks") {
    return (
      <AllTasksVariant
        onSetSelectedTask={(task) => onSetSelectedTask(task)}
        onOpenComments={onOpenComments}
        onOpenDetail={onOpenDetail}
        taskTeam={taskTeam}
        task={task}
        userProfile={userProfile}
        onTaskAction={(action, data) => onTaskAction(action, data)}
        currentUserRole={task.role}
        loadingMember={loadingMember}
      />
    );
  }
};

const DefaultVariant = ({
  task,
  projectTeam,
  onOpenDetail,
  onOpenComments,
  onTaskAction,
  taskSection,
  onSetSelectedTask,
  projectSections,
  isDraggingOver,
  userProfile,
  currentUserRole,
  projectTags,
  setProjectTags,
  onChangeTags,
  getFilteredTasksBySection,
  sections,
  loadingMember = {},
}) => {
  const is_mobile_view = useMediaQuery("(max-width:600px)");
  const {
    task_status,
    task_title,
    createdAt,
    end_date,
    priority,
    team,
    creator_profile,
    extra_status,
    role,
    time_track,
  } = task;
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(null);
  const [openEstimatedTime, setOpenEstimatedTime] = useState();
  const [estimatedTime, setEstimatedTime] = useState("");
  const [submenuOpen, setSubmenuOpen] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  // const [tagExpand, setTagExpand] = useState(false);
  const { tagExpand, setTagExpand } = useAppContext();
  const { dispatch_get_user_profile } = useAppContext();
  // ---------------------------------------------------------
  /* task variants can be 'default','disabled' */

  const handleOpen = (e, task) => {
    console.log(task, "on-select-task");
    onSetSelectedTask(task);
    setOpen(e.currentTarget);
  };
  const handleClose = () => {
    setOpen(null);
  };
  const handleOpenEstimatedtime = (e) => {
    setOpenEstimatedTime(e.target);
  };
  const handleCloseEstimatedTime = () => {
    setOpenEstimatedTime(null);
    setEstimatedTime("");
  };
  const handleOpenSubmenu = (e, task) => {
    e.stopPropagation();
    setSubmenuOpen(e.currentTarget);
  };
  const handleCloseSubmenu = () => {
    setSubmenuOpen(null);
  };
  const handleAction = (action, data) => {
    onTaskAction(action, data);
  };
  const handleCopy = (task) => {
    onTaskAction("copy_task_link", task);
  };
  const onStatusCheckChange = (e) => {
    let checked = e.target.checked;
    const data = {
      checked: checked,
      task: task,
      section: taskSection,
      is_checkbox: true,
    };
    handleAction("change_status", data);
  };
  const onStatusChange = (_data) => {
    const data = {
      task: task,
      section: taskSection,
      status: _data.value,
      is_checkbox: false,
    };
    handleAction("change_status", data);
  };
  const onPriorityChange = (_data) => {
    const data = { task: task, section: taskSection, priority: _data.value };
    handleAction("change_priority", data);
  };
  const onDateChange = (newDate) => {
    const data = { task: task, section: taskSection, endDate: newDate };
    handleAction("change_date", data);
  };
  const canRemoveTeam = (_targetUser, _task) => {
    console.log(currentUserRole, "currentUserRole");
    let current_user_id = userProfile.user_id;
    let target_user_id = _targetUser.user;
    if (String(currentUserRole) === "admin") {
      return true;
    }
    if (String(currentUserRole) === "manager") {
      return true;
    }
    if (
      String(currentUserRole) === "client" ||
      String(currentUserRole) === "client_team"
    ) {
      return true;
    }
    if (String(current_user_id) === String(target_user_id)) {
      console.log("cannot remove yourself");
      return false;
    }
    if (String(currentUserRole) === "team") {
      let found_index_in_team = undefined;
      _task.team.map((item, index) => {
        if (String(item.user) === String(target_user_id)) {
          found_index_in_team = index;
          console.log(item, "ff");
        }
      });
      console.log(found_index_in_team, "found_index_in_team");
      if (
        String(current_user_id) ===
        String(_task.team_assign_by[found_index_in_team])
      ) {
        console.log("you can remove");
      }
      return true;
    }
    return false;
  };
  const onTeamChange = (target_user, task_team, is_selected, action) => {
    const data = {
      task: task,
      section: taskSection,
      taskTeam: task_team,
      targetUser: target_user,
      isSelected: is_selected,
      action: action,
    };
    console.log(data, "team-req");
    if (String(data.action) === "remove") {
      let res = canRemoveTeam(data.targetUser, data.task);
      console.log(res, "canRemoveTeam");
      if (res === false) {
        return;
      }
    }
    handleAction("change_members", data);
  };
  const isChecked = () => {
    if (String(task_status) === "3") {
      return true;
    }

    if (String(task_status) === "4") {
      return true;
    }
    return false;
  };
  const onMove = (e, move_to) => {
    e.stopPropagation();
    handleClose();
    handleCloseSubmenu();
    const data = {
      moveTo: move_to,
      sourceTaskSection: taskSection,
      sourceTask: task,
    };
    handleAction("move_task", data);
  };
  const allowDateAction = () => {
    if (task.creator_profile?.user_id === dispatch_get_user_profile().user_id) {
      return true;
    }
    if (task.user_task_status === true) {
      return true;
    }
    if (String(currentUserRole) === "admin") {
      return true;
    }
    if (String(currentUserRole) === "manager") {
      return true;
    }
    if (String(currentUserRole) === "team") {
      return true;
    }
    if (
      String(currentUserRole) === "client" ||
      String(currentUserRole) === "client_team"
    ) {
      return true;
    }
    return false;
  };
  const allowMoveToWorkspace = () => {
    if (task.linking_status == "parent" && !task.linked_task_id) {
      return true;
    } else {
      return false;
    }
  };
  const excludedStatusOptions = () => {
    if (!currentUserRole) {
      return [5];
    }
    if (creator_profile.user_id === dispatch_get_user_profile().user_id) {
      return [5];
    }
    if (currentUserRole === "admin") {
      return [5];
    }
    if (currentUserRole === "manager") {
      return [5];
    }
    if (currentUserRole === "client" || currentUserRole === "client_team") {
      return [5];
    }
    if (currentUserRole === "team") {
      return [4, 5]; /* exclude verified status for team */
    }
  };
  const updateTimeTrack = async () => {
    if (!estimatedTime) {
      enqueueSnackbar("Please add estimated time", { variant: "error" });
      return;
    }
    try {
      const reqObj = {
        task_id: task._id,
        task_time: {
          ...task.time_track,
          estimated_time:
            estimatedTime && !estimatedTime.includes(":")
              ? estimatedTime.padStart(2, "0") + ":00"
              : estimatedTime &&
                estimatedTime.includes(":") &&
                estimatedTime.split(":")[1].length < 2
              ? estimatedTime.split(":")[0] +
                ":" +
                estimatedTime.split(":")[1].padStart(2, "0")
              : estimatedTime,
        },
      };
      const result = await _update_time_track(reqObj);
      if (result.code == 200) {
        handleCloseEstimatedTime();
        getFilteredTasksBySection(task.section_id);
      }
    } catch (error) {
      console.log(error, " catched while updating time track");
    }
  };
  const handleScroll = () => {
    const elm = document.getElementById(task._id);
    if (elm) {
      if (task.scroll_to_view === true) {
        setTimeout(() => {
          elm.scrollIntoView({ block: "center", behavior: "auto" });
          elm.classList.add("highlight-task");
        }, 500);
        // navigate(location.pathname, { state: null });
        setTimeout(() => {
          elm.classList.remove("highlight-task");
        }, 3500);
      }
    }
  };
  // useEffect(() => {
  //   handleScroll();
  // }, []);

  /* <<--------------------------------------------------------->> */
  return (
    <React.Fragment>
      <Paper
        id={task._id}
        onClick={(e) => {
          if (e.target.closest("a")) {
            // if click on Link dont open detail - shamroz
            console.log(e.target, "link_opened");
            return;
          }
          console.log(task, "task");
          onOpenDetail(task);
        }}
        elevation={3}
        className={`${isDraggingOver ? "is-dragging" : ""}`}
        sx={{
          width: 1,
          borderRadius: "0.3rem",
          p: 0.7,
          pt: 0.9,
          pb: 0.9,
          position: "relative",
          pr: 7.5,
          overflow: "hidden",
        }}
      >
        <Stack spacing={0.3}>
          <Stack {...stack_props}>
            <Checkbox
              sx={{ mb: "auto", p: "4px" }}
              value={task_status}
              onChange={onStatusCheckChange}
              checked={isChecked()}
              onClick={(e) => e.stopPropagation()}
            />
            <Typography
              role="button"
              sx={{ cursor: "pointer", maxHeight: "128px", overflow: "hidden" }}
              // onClick={(e) => {
              //   // if(e.target.id=="clickablelink"){
              //   //   return;
              //   // }
              //   onOpenDetail(task);
              // }}
            >
              <div
                dangerouslySetInnerHTML={replacedText(task_title)}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }}
              />
            </Typography>
          </Stack>

          <Grid container>
            <Grid
              sx={{
                paddingLeft: "9px",
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                minWidth: 0,
              }}
              item
              flexGrow={1}
            >
              <Grid id="actions" direction="row" container>
                {/* =======  Horizontal Scroller for Mobile/Tablet (below md) ======= */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: { xs: "block", md: "none" },
                    overflowX: "auto",
                    width: "100%",
                    "&::-webkit-scrollbar": {
                      height: "3px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: (theme) => theme.palette.divider,
                      borderRadius: "10px",
                    },
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={2.5}
                    sx={{
                      width: { xs: "max-content", md: "100%" },
                      padding: { xs: "0px 0px 8px 0px", md: "0px" },
                      py: 1,
                    }}
                  >
                    {/* 1. Target Date */}
                    <span onClick={(e) => e.stopPropagation()}>
                      <TaskDatePick
                        hasPortal
                        value={end_date}
                        onChange={(newDate) => onDateChange(newDate)}
                        task={task}
                        disabled={!allowDateAction()}
                      />
                    </span>

                    {/* 2. Metadata Icons */}
                    <Stack
                      columnGap={0.7}
                      direction="row"
                      alignItems="center"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Tooltip
                        title={`created by ${
                          creator_profile.first_name +
                          " " +
                          creator_profile.last_name
                        }`}
                      >
                        <div onClick={(e) => e.stopPropagation()}>
                          <UserAvatar
                            sx={{ width: 35, height: 35 }}
                            image={creator_profile.image}
                            alt="task creator"
                            name={
                              creator_profile.first_name +
                              " " +
                              creator_profile.last_name
                            }
                          />
                        </div>
                      </Tooltip>
                      <TaskCreatedAt date={createdAt} />
                      <PriorityPopover
                        onChange={(data) => onPriorityChange(data)}
                        allowOpen
                        value={priority}
                      />
                      <StatusPopover
                        extraStatus={extra_status}
                        onChange={(data) => onStatusChange(data)}
                        allowOpen={true}
                        excludedOptions={excludedStatusOptions()}
                        value={task_status}
                      />
                      <div className="pointer">
                        <Tooltip title="Comments">
                          <Stack
                            // Dont open comment drawer instead open task detail & scroll to comment
                            // onClick(() => onOpenComments(task))
                            onClick={(e) => {
                              onOpenDetail(task);

                              requestAnimationFrame(() => {
                                requestAnimationFrame(() => {
                                  const el = document.querySelector("[data-comments-section]");
                                  el?.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start",
                                  });
                                });
                              });
                            }}
                            // -------------------------------------------------
                            direction="row"
                            alignItems="center"
                            spacing={0.1}
                          >
                            <Badge
                              badgeContent=""
                              color="error"
                              invisible={task.task_comment_unread_count == 0}
                              variant="dot"
                              anchorOrigin={{
                                vertical: "top",
                                horizontal: "left",
                              }}
                            >
                              <Iconify
                                sx={{
                                  height: 17,
                                  width: 17,
                                  color: icon_color,
                                }}
                                icon="majesticons:comment-text"
                              />
                            </Badge>
                            <Typography variant="body2">
                              {task.task_comment.length}
                            </Typography>
                          </Stack>
                        </Tooltip>
                      </div>
                      {task?.task_description && (
                        <div className="pointer">
                          <Tooltip title="Description">
                            <Stack
                              onClick={() => onOpenDetail(task)}
                              direction="row"
                              alignItems="center"
                              spacing={0.1}
                            >
                              <Iconify
                                sx={{
                                  height: 17,
                                  width: 17,
                                  color: icon_color,
                                }}
                                icon="fluent:text-description-32-filled"
                              />
                            </Stack>
                          </Tooltip>
                        </div>
                      )}
                      {task?.check_list.length > 0 && (
                        <div className="pointer">
                          <Tooltip title="Checklists">
                            <Stack
                              onClick={() => onOpenDetail(task)}
                              direction="row"
                              alignItems="center"
                              spacing={0.1}
                            >
                              <Iconify
                                sx={{
                                  height: 17,
                                  width: 17,
                                  color: icon_color,
                                }}
                                icon="tabler:checkbox"
                              />
                              <Typography variant="body2">
                                {task.check_list.length}
                              </Typography>
                            </Stack>
                          </Tooltip>
                        </div>
                      )}
                      <div onClick={() => handleCopy(task)} className="pointer">
                        <Tooltip title="Copy task link">
                          <div>
                            <Iconify
                              sx={{ height: 17, width: 17, color: icon_color }}
                              icon="clarity:copy-line"
                            />
                          </div>
                        </Tooltip>
                      </div>
                      <LabelPopup
                        projectId={task.project.id}
                        projectTags={projectTags}
                        setProjectTags={setProjectTags}
                        task={task}
                        onChangeTags={onChangeTags}
                        sections={sections}
                        getFilteredTasksBySection={getFilteredTasksBySection}
                      />
                      {task?.attachments?.length > 0 && (
                        <div
                          className="pointer"
                          onClick={() => onOpenDetail(task)}
                        >
                          <Tooltip title="Attachments">
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={0.1}
                            >
                              <Iconify
                                sx={{
                                  height: 17,
                                  width: 17,
                                  color: icon_color,
                                }}
                                icon="mi:attachment"
                              />
                              <Typography variant="body2">
                                {task?.attachments?.length}
                              </Typography>
                            </Stack>
                          </Tooltip>
                        </div>
                      )}
                    </Stack>

                    {/* 3. Team and Time */}
                    <Stack
                      spacing={1.5}
                      direction="row"
                      alignItems="center"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="d-flex">
                        {team.length === 0 ? (
                          <Avatar
                            sx={{
                              height: 29,
                              width: 29,
                              bgcolor: isDraggingOver ? "#68ffa7" : "white",
                            }}
                          >
                            .
                          </Avatar>
                        ) : (
                          <TeamMembers
                            disabled={false}
                            allowOpen={true}
                            taskTeam={team}
                            projectTeam={projectTeam}
                            onChange={(
                              target_user,
                              taskTeam,
                              is_selected,
                              action
                            ) =>
                              onTeamChange(
                                target_user,
                                taskTeam,
                                is_selected,
                                action
                              )
                            }
                          />
                        )}
                        <TeamPicker
                          onChange={(
                            target_user,
                            taskTeam,
                            is_selected,
                            action
                          ) =>
                            onTeamChange(
                              target_user,
                              taskTeam,
                              is_selected,
                              action
                            )
                          }
                          allowOpen
                          taskTeam={team}
                          projectTeam={projectTeam}
                          loadingMember={loadingMember}
                        />
                      </div>
                      <Stack direction="row" alignItems="center" spacing={0.5}>
                        {(role === "team" ||
                          role === "admin" ||
                          role === "manager" ||
                          (role === "client" &&
                            (task?.creator_profile?.user_id ===
                              dispatch_get_user_profile().user_id ||
                              task?.team?.some(
                                (teamMember) =>
                                  teamMember.user_id ===
                                  dispatch_get_user_profile().user_id
                              )))) &&
                          time_track.estimated_time && (
                            <Label
                              variant="ghost"
                              color="info"
                              startIcon={
                                <Iconify icon={"ic:outline-access-time"} />
                              }
                            >
                              Estimate: {time_track.estimated_time}
                            </Label>
                          )}
                        {(role == "team" ||
                          role == "admin" ||
                          role == "manager") &&
                          task_status == 3 &&
                          time_track.actual_time && (
                            <Label
                              variant="ghost"
                              color="info"
                              startIcon={
                                <Iconify icon={"ic:outline-access-time"} />
                              }
                            >
                              Completed: {time_track.actual_time}
                            </Label>
                          )}
                        {(role == "admin" || role == "manager") &&
                          time_track.final_time && (
                            <Label
                              variant="ghost"
                              color="info"
                              startIcon={
                                <Iconify icon={"ic:outline-access-time"} />
                              }
                            >
                              Billable: {time_track.final_time}
                            </Label>
                          )}
                        {(role == "client" || role == "client_team") &&
                          time_track.final_time &&
                          task_status == 3 && (
                            <Label
                              variant="ghost"
                              color="info"
                              startIcon={
                                <Iconify icon={"ic:outline-access-time"} />
                              }
                            >
                              Completed: {time_track.final_time}
                            </Label>
                          )}
                      </Stack>
                    </Stack>
                  </Stack>
                </Grid>

                {/* ======= Grid Components for Desktop (md and above) ======= */}
                <Grid
                  sx={{
                    display: { xs: "none", md: "flex" },
                    alignItems: "center",
                  }}
                  item
                  md={2}
                >
                  <span onClick={(e) => e.stopPropagation()}>
                    <TaskDatePick
                      hasPortal
                      value={end_date}
                      onChange={(newDate) => onDateChange(newDate)}
                      task={task}
                      disabled={!allowDateAction()}
                    />
                  </span>
                </Grid>

                <Grid
                  sx={{
                    display: { xs: "none", md: "flex" },
                    alignItems: "center",
                    justifyContent: "start",
                    paddingLeft: "30px",
                  }}
                  item
                  md={5.5}
                >
                  <Stack
                    justifyContent="center"
                    columnGap={0.7}
                    direction="row"
                    alignItems="center"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Tooltip
                      title={`created by ${
                        creator_profile.first_name +
                        " " +
                        creator_profile.last_name
                      }`}
                    >
                      <div onClick={(e) => e.stopPropagation()}>
                        <UserAvatar
                          sx={{ width: 35, height: 35 }}
                          image={creator_profile.image}
                          alt="task creator"
                          name={
                            creator_profile.first_name +
                            " " +
                            creator_profile.last_name
                          }
                        />
                      </div>
                    </Tooltip>
                    <TaskCreatedAt date={createdAt} />
                    <PriorityPopover
                      onChange={(data) => onPriorityChange(data)}
                      allowOpen
                      value={priority}
                    />
                    <StatusPopover
                      extraStatus={extra_status}
                      onChange={(data) => onStatusChange(data)}
                      allowOpen={true}
                      excludedOptions={excludedStatusOptions()}
                      value={task_status}
                    />
                    <div className="pointer">
                      <Tooltip title="Comments">
                        <Stack
                          // Dont open comment drawer instead open task detail & scroll to comment
                          // onClick(() => onOpenComments(task))
                          onClick={(e) => {
                            onOpenDetail(task);
                            setTimeout(() => {
                              const commentsSection = document.querySelector('[data-comments-section]');
                              if (commentsSection) {
                                commentsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                              }
                            }, 2000);
                          }}
                          // -------------------------------------------------
                          direction="row"
                          alignItems="center"
                          spacing={0.1}
                        >
                          <Badge
                            badgeContent=""
                            color="error"
                            invisible={task.task_comment_unread_count == 0}
                            variant="dot"
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                          >
                            <Iconify
                              sx={{
                                height: 17,
                                width: 17,
                                color: icon_color,
                              }}
                              icon="majesticons:comment-text"
                            />
                          </Badge>
                          <Typography variant="body2">
                            {task.task_comment.length}
                          </Typography>
                        </Stack>
                      </Tooltip>
                    </div>
                    {task?.task_description && (
                      <div className="pointer">
                        <Tooltip title="Description">
                          <Stack
                            onClick={() => onOpenDetail(task)}
                            direction="row"
                            alignItems="center"
                            spacing={0.1}
                          >
                            <Iconify
                              sx={{
                                height: 17,
                                width: 17,
                                color: icon_color,
                              }}
                              icon="fluent:text-description-32-filled"
                            />
                          </Stack>
                        </Tooltip>
                      </div>
                    )}
                    {task?.check_list.length > 0 && (
                      <div className="pointer">
                        <Tooltip title="Checklists">
                          <Stack
                            onClick={() => onOpenDetail(task)}
                            direction="row"
                            alignItems="center"
                            spacing={0.1}
                          >
                            <Iconify
                              sx={{
                                height: 17,
                                width: 17,
                                color: icon_color,
                              }}
                              icon="tabler:checkbox"
                            />
                            <Typography variant="body2">
                              {task.check_list.length}
                            </Typography>
                          </Stack>
                        </Tooltip>
                      </div>
                    )}
                    <div onClick={() => handleCopy(task)} className="pointer">
                      <Tooltip title="Copy task link">
                        <div>
                          <Iconify
                            sx={{ height: 17, width: 17, color: icon_color }}
                            icon="clarity:copy-line"
                          />
                        </div>
                      </Tooltip>
                    </div>
                    <LabelPopup
                      projectId={task.project.id}
                      projectTags={projectTags}
                      setProjectTags={setProjectTags}
                      task={task}
                      onChangeTags={onChangeTags}
                      sections={sections}
                      getFilteredTasksBySection={getFilteredTasksBySection}
                    />
                    {task?.attachments?.length > 0 && (
                      <div
                        className="pointer"
                        onClick={() => onOpenDetail(task)}
                      >
                        <Tooltip title="Attachments">
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={0.1}
                          >
                            <Iconify
                              sx={{
                                height: 17,
                                width: 17,
                                color: icon_color,
                              }}
                              icon="mi:attachment"
                            />
                            <Typography variant="body2">
                              {task?.attachments?.length}
                            </Typography>
                          </Stack>
                        </Tooltip>
                      </div>
                    )}
                  </Stack>
                </Grid>
                <Grid
                  item
                  md={4.5}
                  sx={{
                    display: { xs: "none", md: "flex" },
                    paddingLeft: "40px",
                    justifyContent: "flex-end",
                  }}
                >
                  <Stack
                    justifyContent="space-between"
                    columnGap={0.7}
                    direction="row"
                    alignItems="center"
                    sx={{ width: "100%" }}
                    onClick={() => onOpenDetail(task)}
                  >
                    <div
                      className="d-flex"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {team.length === 0 ? (
                        <Avatar
                          sx={{
                            height: 29,
                            width: 29,
                            bgcolor: isDraggingOver ? "#68ffa7" : "white",
                          }}
                        >
                          .
                        </Avatar>
                      ) : (
                        <TeamMembers
                          disabled={false}
                          allowOpen={true}
                          taskTeam={team}
                          projectTeam={projectTeam}
                          onChange={(
                            target_user,
                            taskTeam,
                            is_selected,
                            action
                          ) =>
                            onTeamChange(
                              target_user,
                              taskTeam,
                              is_selected,
                              action
                            )
                          }
                        />
                      )}
                      <TeamPicker
                        onChange={(
                          target_user,
                          taskTeam,
                          is_selected,
                          action
                        ) =>
                          onTeamChange(
                            target_user,
                            taskTeam,
                            is_selected,
                            action
                          )
                        }
                        allowOpen
                        taskTeam={team}
                        projectTeam={projectTeam}
                        loadingMember={loadingMember}
                      />
                    </div>
                    <Stack
                      direction={{ xs: "row", md: "column" }}
                      alignItems={{ xs: "center", md: "flex-end" }}
                      spacing={0.5}
                    >
                      {(role === "team" ||
                        role === "admin" ||
                        role === "manager" ||
                        (role === "client" &&
                          (task?.creator_profile?.user_id ===
                            dispatch_get_user_profile().user_id ||
                            task?.team?.some(
                              (teamMember) =>
                                teamMember.user_id ===
                                dispatch_get_user_profile().user_id
                            )))) &&
                        time_track.estimated_time && (
                          <Label
                            variant="ghost"
                            color="info"
                            startIcon={
                              <Iconify icon={"ic:outline-access-time"} />
                            }
                          >
                            Estimate: {time_track.estimated_time}
                          </Label>
                        )}
                      {(role == "team" ||
                        role == "admin" ||
                        role == "manager") &&
                        task_status == 3 &&
                        time_track.actual_time && (
                          <Label
                            variant="ghost"
                            color="info"
                            startIcon={
                              <Iconify icon={"ic:outline-access-time"} />
                            }
                          >
                            Completed: {time_track.actual_time}
                          </Label>
                        )}
                      {(role == "admin" || role == "manager") &&
                        time_track.final_time && (
                          <Label
                            variant="ghost"
                            color="info"
                            startIcon={
                              <Iconify icon={"ic:outline-access-time"} />
                            }
                          >
                            Billable: {time_track.final_time}
                          </Label>
                        )}
                      {(role == "client" || role == "client_team") &&
                        time_track.final_time &&
                        task_status == 3 && (
                          <Label
                            variant="ghost"
                            color="info"
                            startIcon={
                              <Iconify icon={"ic:outline-access-time"} />
                            }
                          >
                            Completed: {time_track.final_time}
                          </Label>
                        )}
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Stack>
        {task.tag_colors.length > 0 && (
          <Box
            sx={{
              overflowX: { xs: "auto", lg: "visible" },
              width: "100%",
              pt: 1,
              pl: 0.9,
              "&::-webkit-scrollbar": {
                height: "3px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: (theme) => theme.palette.divider,
                borderRadius: "10px",
              },
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Stack
              direction={"row"}
              spacing={1}
              flexWrap={{ xs: "nowrap", md: "wrap" }}
              sx={{
                width: { xs: "max-content", md: "100%" },
                padding: { xs: "8px 0px 12px", md: "0px" },
              }}
            >
              {task.tag_colors.map((tag) => (
                <Tooltip title={tag.name ? tag.name : ""} key={tag._id}>
                  <div
                    style={{
                      display: "flex",
                      padding: "3px 5px",
                      backgroundColor: tagExpand ? "#f5f5f5" : tag.color_code,
                      borderRadius: "4px",
                      minWidth: "50px",
                      maxWidth: tagExpand ? "max-content" : "100px",
                      maxHeight: tagExpand ? "20px" : "7px",
                      minHeight: "7px",
                      fontSize: "10px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      // color: isColorLight(tag.color_code) ? "#000" : "#fff",
                      transition: "max-height 0.3s ease",
                      cursor: "pointer",
                      borderLeft: tagExpand
                        ? `4px solid ${tag.color_code}`
                        : "none",
                    }}
                    onClick={() => setTagExpand((prev) => !prev)}
                  >
                    {tagExpand && tag.name}
                  </div>
                </Tooltip>
              ))}
            </Stack>
          </Box>
        )}
        <div onClick={(e) => e.stopPropagation()}>
          <div className="task-card-menu-btn">
            <IconButton
              sx={{ p: "3px" }}
              onClick={(e) => {
                handleOpen(e, task);
              }}
            >
              <Iconify
                sx={{ color: icon_color }}
                icon="bi:three-dots-vertical"
              />
            </IconButton>
          </div>
          <Menu
            disableEnforceFocus
            anchorEl={open}
            open={Boolean(open)}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            sx={{
              p: 0.5,
              "& .MuiMenuItem-root": {
                typography: "body2",
                borderRadius: 0.5,
                mx: 0.5,
              },
            }}
          >
            {(currentUserRole == "admin" ||
              currentUserRole == "manager" ||
              task.creator_profile.user_id ==
                dispatch_get_user_profile().user_id) && (
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  onTaskAction("del_task", task);
                  handleClose();
                }}
              >
                Delete
                <span style={{ marginLeft: "auto" }}>
                  <Iconify
                    sx={{ ml: "8px", ...menu_item_icon_size }}
                    icon="dashicons:trash"
                  />
                </span>
              </MenuItem>
            )}
            {(currentUserRole == "admin" || currentUserRole == "manager") &&
              allowMoveToWorkspace() && (
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    onTaskAction("move_to_workspace", task);
                    handleClose();
                  }}
                >
                  Copy to other workspace
                  <span style={{ marginLeft: "auto" }}>
                    <Iconify
                      sx={{ ml: "8px", ...menu_item_icon_size }}
                      icon="mingcute:copy-fill"
                    />
                  </span>
                </MenuItem>
              )}
            {projectSections && (
              <MenuItem onClick={handleOpenSubmenu}>
                Move to other section
                <span style={{ marginLeft: "auto" }}>
                  <Iconify
                    sx={{ ml: "8px", ...menu_item_icon_size }}
                    icon="mdi:rotate-3d-variant"
                  />
                </span>
              </MenuItem>
            )}
            {/*  */}
            {projectSections && (
              <Menu
                disableEnforceFocus
                anchorEl={submenuOpen}
                open={Boolean(submenuOpen)}
                onClose={handleCloseSubmenu}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                sx={{
                  p: 0.5,
                  mt: 1.5,
                  ml: -1,
                  marginRight: "44rem",
                  "& .MuiMenuItem-root": {
                    typography: "body2",
                    borderRadius: 0.5,
                    mx: 0.5,
                  },
                  "& .MuiPaper-root": {
                    left: "923px",
                  },
                }}
              >
                {projectSections.map((item) => {
                  return (
                    <MenuItem onClick={(e) => onMove(e, item)} key={item._id}>
                      {item.section_title}
                    </MenuItem>
                  );
                })}
                {projectSections.length === 0 && (
                  <MenuItem disabled disableRipple>
                    <Typography
                      variant="body2"
                      sx={{ color: (theme) => theme.palette.text.disabled }}
                    >
                      No sections
                    </Typography>
                  </MenuItem>
                )}
              </Menu>
            )}
          </Menu>
        </div>

        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", md: "end" }}
          spacing={{ xs: 1, md: 0 }}
          sx={{ px: 1, pb: 0.5, mt: 1 }}
        >
          {/* 1. Working on task (Start) */}
          <div className="working-on-task">
            {task?.time_tracking &&
              task?.time_tracking.map(
                (time_block) =>
                  time_block.tracking_status === "start" && (
                    <div
                      className="d-flex align-items-center"
                      key={time_block.assignee.user_id}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <Iconify
                        icon="material-symbols:circle"
                        color="#3366FF"
                        fontSize="10px"
                        marginRight="5px"
                      />
                      <Typography
                        sx={{
                          fontSize: "10px",
                          color: "#637381",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span style={{ fontWeight: 600, paddingRight: "3px" }}>
                          {time_block.assignee.user_id ===
                          dispatch_get_user_profile().user_id
                            ? "You're"
                            : `${time_block.assignee.first_name} ${time_block.assignee.last_name}`}
                        </span>
                        currently working on this task
                      </Typography>
                    </div>
                  )
              )}
          </div>

          {/* 2. Checklist stats (End) */}
          <Stack direction="row" spacing={1} alignItems="center">
            {task.task_checklist_stats?.improvements_stats?.total_count > 0 && (
              <Feedback task={task} />
            )}
            {task.task_checklist_stats?.issues_stats?.total_count > 0 && (
              <IssueReport task={task} />
            )}
          </Stack>
        </Stack>
      </Paper>
    </React.Fragment>
  );
};
const AllTasksVariant = ({
  task,
  taskTeam,
  onOpenDetail,
  onOpenComments,
  onTaskAction,
  onSetSelectedTask,
  userProfile,
  currentUserRole,
  loadingMember = {},
}) => {
  const is_mobile_view = useMediaQuery("(max-width:600px)");

  const {
    createdAt,
    end_date,
    creator_profile,
    image,
    order,
    priority,
    project_id,
  } = task;
  const { task_title, section_id, status, task_action_by } = task;
  const {
    task_action_id,
    task_comment,
    task_comment_count,
    task_description,
    teamAssignBy,
    extra_status,
  } = task;
  const { task_status, task_type, team, workspace_id, _id } = task;
  const [open, setOpen] = useState(null);
  const [submenuOpen, setSubmenuOpen] = useState(null);
  const [loadingTeam, setLoadingTeam] = useState(true);
  const [taskProjectTeam, setTaskProjectTeam] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  // ---------------------------------------------------------
  /* task variants can be 'default','disabled' */

  const handleOpen = (e, task) => {
    console.log(task, "on-select-task");
    onSetSelectedTask(task);
    setOpen(e.currentTarget);
  };
  const handleClose = () => {
    setOpen(null);
  };
  const handleOpenSubmenu = (e, task) => {
    e.stopPropagation();
    setSubmenuOpen(e.currentTarget);
  };
  const handleCloseSubmenu = () => {
    setSubmenuOpen(null);
  };
  const handleAction = (action, data) => {
    onTaskAction(action, data);
  };
  const handleCopy = (task) => {
    onTaskAction("copy_task_link", task);
  };
  const onStatusCheckChange = (e) => {
    let checked = e.target.checked;
    const data = {
      checked: checked,
      task: task,
      is_checkbox: true,
    };
    handleAction("change_status", data);
  };
  const onStatusChange = (_data) => {
    const data = {
      task: task,
      status: _data.value,
      is_checkbox: false,
    };
    handleAction("change_status", data);
  };
  const onPriorityChange = (_data) => {
    const data = { task: task, priority: _data.value };
    handleAction("change_priority", data);
  };
  const onDateChange = (newDate) => {
    console.log(newDate, "new-date-on-change");
    const data = { task: task, endDate: newDate };
    handleAction("change_date", data);
  };
  const canRemoveTeam = (_targetUser, _task) => {
    console.log(currentUserRole, "currentUserRole");
    let current_user_id = userProfile.user_id;
    let target_user_id = _targetUser.user;
    if (String(currentUserRole) === "admin") {
      return true;
    }
    if (String(currentUserRole) === "manager") {
      return true;
    }
    if (String(current_user_id) === String(target_user_id)) {
      console.log("cannot remove yourself");
      return false;
    }
    if (String(currentUserRole) === "team") {
      let found_index_in_team = undefined;
      _task.team.map((item, index) => {
        if (String(item.user) === String(target_user_id)) {
          found_index_in_team = index;
          console.log(item, "ff");
        }
      });
      console.log(found_index_in_team, "found_index_in_team");
      if (
        String(current_user_id) ===
        String(_task.team_assign_by[found_index_in_team])
      ) {
        console.log("you can remove");
      }
      return true;
    }
    return false;
  };
  const onTeamChange = (target_user, task_team, is_selected, action) => {
    const data = {
      task: task,
      taskTeam: task_team,
      targetUser: target_user,
      isSelected: is_selected,
      action: action,
    };
    console.log(data, "team-req");
    if (String(data.action) === "remove") {
      let res = canRemoveTeam(data.targetUser, data.task);
      console.log(res, "canRemoveTeam");
      if (res === false) {
        return;
      }
    }
    handleAction("change_members", data);
  };
  const isChecked = () => {
    if (String(task_status) === "3") {
      return true;
    }

    if (String(task_status) === "4") {
      return true;
    }
    return false;
  };

  const allowDateAction = () => {
    return true;
    if (task.creator_profile.user_id === dispatch_get_user_profile().user_id) {
      return true;
    }
    if (task.user_task_status === true) {
      return true;
    }
    if (String(currentUserRole) === "admin") {
      return true;
    }
    if (String(currentUserRole) === "manager") {
      return true;
    }
    if (String(currentUserRole) === "team") {
      return false;
    }
    return false;
  };
  const excludedStatusOptions = () => {
    if (!currentUserRole) {
      return [5];
    }
    if (creator_profile.user_id === dispatch_get_user_profile().user_id) {
      return [5];
    }
    if (currentUserRole === "admin") {
      return [5];
    }
    if (currentUserRole === "manager") {
      return [5];
    }
    if (currentUserRole === "client" || currentUserRole === "client_team") {
      return [5];
    }
    if (currentUserRole === "team") {
      return [4, 5]; /* exclude verified status for team */
    }
  };
  const getTaskProjectTeam = async () => {
    // setLoadingTeam(true);
    const result = await _project_team(null, task.project_id);
    if (result.code === 200) {
      setTaskProjectTeam(result.project_team_list.team);
      setLoadingTeam(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setLoadingTeam(false);
    }
  };
  useEffect(() => {
    return () => {
      setTaskProjectTeam([]);
    };
  }, []);
  /* <<--------------------------------------------------------->> */
  return (
    <React.Fragment>
      <Paper
        id={task._id}
        onClick={() => console.log(task, "task")}
        elevation={3}
        sx={{
          width: 1,
          borderRadius: "0.3rem",
          p: 0.7,
          pt: 0.9,
          position: "relative",
          pr: 7.5,
        }}
      >
        <Stack spacing={0.3}>
          <Stack {...stack_props}>
            <Checkbox
              sx={{ mb: "auto", p: "4px" }}
              value={task_status}
              onChange={onStatusCheckChange}
              checked={isChecked()}
            />
            <Typography
              role="button"
              sx={{ cursor: "pointer", maxHeight: "128px", overflow: "hidden" }}
              onClick={(e) => {
                // if(e.target.id=="clickablelink"){
                //   return;
                // }
                onOpenDetail(task);
              }}
            >
              <div dangerouslySetInnerHTML={replacedText(task_title)} />
            </Typography>
          </Stack>
          <Grid container>
            <Grid
              sx={{
                paddingLeft: "9px",
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                minWidth: 0,
              }}
              item
              flexGrow={1}
            >
              <Grid id="actions" direction="row" container>
                {/* =======  Horizontal Scroller for Mobile/Tablet (below md) ======= */}

                <Grid
                  item
                  xs={12}
                  sx={{
                    display: { xs: "block", md: "none" },
                    overflowX: "auto",
                    width: "100%",
                    "&::-webkit-scrollbar": {
                      height: "3px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: (theme) => theme.palette.divider,
                      borderRadius: "10px",
                    },
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={2.5}
                    sx={{
                      width: { xs: "max-content", md: "100%" },
                      padding: { xs: "0px 0px 8px 0px", md: "0px" },
                      py: 1,
                    }}
                  >
                    {/* 1. Target Date */}
                    <span onClick={(e) => e.stopPropagation()}>
                      <TaskDatePick
                        hasPortal
                        value={end_date}
                        onChange={(newDate) => onDateChange(newDate)}
                        task={task}
                        disabled={!allowDateAction()}
                      />
                    </span>

                    {/* 2. Metadata Icons */}
                    <Stack
                      columnGap={0.7}
                      direction="row"
                      alignItems="center"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Tooltip
                        title={`created by ${
                          creator_profile.first_name +
                          " " +
                          creator_profile.last_name
                        }`}
                      >
                        <div onClick={(e) => e.stopPropagation()}>
                          <UserAvatar
                            sx={{ width: 35, height: 35 }}
                            image={creator_profile.image}
                            alt="task creator"
                            name={
                              creator_profile.first_name +
                              " " +
                              creator_profile.last_name
                            }
                          />
                        </div>
                      </Tooltip>
                      <TaskCreatedAt date={createdAt} />
                      <PriorityPopover
                        onChange={(data) => onPriorityChange(data)}
                        allowOpen
                        value={priority}
                      />
                      <StatusPopover
                        extraStatus={extra_status}
                        onChange={(data) => onStatusChange(data)}
                        allowOpen={true}
                        excludedOptions={excludedStatusOptions()}
                        value={task_status}
                      />
                      <div className="pointer">
                        <Tooltip title="Comments">
                          <Stack
                            // Dont open comment drawer instead open task detail & scroll to comment
                            // onClick(() => onOpenComments(task))
                            onClick={(e) => {
                              onOpenDetail(task);
                              requestAnimationFrame(() => {
                                requestAnimationFrame(() => {
                                  const el = document.querySelector("[data-comments-section]");
                                  el?.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start",
                                  });
                                });
                              });
                            }}
                            // -------------------------------------------------
                            direction="row"
                            alignItems="center"
                            spacing={0.1}
                          >
                            <Badge
                              badgeContent=""
                              color="error"
                              invisible={task.task_comment_unread_count == 0}
                              variant="dot"
                              anchorOrigin={{
                                vertical: "top",
                                horizontal: "left",
                              }}
                            >
                              <Iconify
                                sx={{
                                  height: 17,
                                  width: 17,
                                  color: icon_color,
                                }}
                                icon="majesticons:comment-text"
                              />
                            </Badge>
                            <Typography variant="body2">
                              {task.task_comment.length}
                            </Typography>
                          </Stack>
                        </Tooltip>
                      </div>
                      {task?.task_description && (
                        <div className="pointer">
                          <Tooltip title="Description">
                            <Stack
                              onClick={() => onOpenDetail(task)}
                              direction="row"
                              alignItems="center"
                              spacing={0.1}
                            >
                              <Iconify
                                sx={{
                                  height: 17,
                                  width: 17,
                                  color: icon_color,
                                }}
                                icon="fluent:text-description-32-filled"
                              />
                            </Stack>
                          </Tooltip>
                        </div>
                      )}

                      {task?.check_list.length > 0 && (
                        <div className="pointer">
                          <Tooltip title="Checklists">
                            <Stack
                              onClick={() => onOpenDetail(task)}
                              direction="row"
                              alignItems="center"
                              spacing={0.1}
                            >
                              <Iconify
                                sx={{
                                  height: 17,
                                  width: 17,
                                  color: icon_color,
                                }}
                                icon="tabler:checkbox"
                              />
                              <Typography variant="body2">
                                {task.check_list.length}
                              </Typography>
                            </Stack>
                          </Tooltip>
                        </div>
                      )}
                      <div onClick={() => handleCopy(task)} className="pointer">
                        <Tooltip title="Copy task link">
                          <div>
                            <Iconify
                              sx={{ height: 17, width: 17, color: icon_color }}
                              icon="clarity:copy-line"
                            />
                          </div>
                        </Tooltip>
                      </div>
                    </Stack>

                    {/* 3. Team and Time */}
                    <Stack
                      spacing={1.5}
                      direction="row"
                      alignItems="center"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="d-flex">
                        {team.length === 0 ? (
                          <Avatar
                            sx={{
                              height: 29,
                              width: 29,
                              bgcolor: isDraggingOver ? "#68ffa7" : "white",
                            }}
                          >
                            .
                          </Avatar>
                        ) : (
                          <TeamMembers
                            disabled={false}
                            allowOpen={true}
                            taskTeam={team}
                            projectTeam={taskTeam}
                            onChange={(
                              target_user,
                              taskTeam,
                              is_selected,
                              action
                            ) =>
                              onTeamChange(
                                target_user,
                                taskTeam,
                                is_selected,
                                action
                              )
                            }
                          />
                        )}
                        <TeamPicker
                          onChange={(
                            target_user,
                            taskTeam,
                            is_selected,
                            action
                          ) =>
                            onTeamChange(
                              target_user,
                              taskTeam,
                              is_selected,
                              action
                            )
                          }
                          allowOpen
                          taskTeam={team}
                          projectTeam={taskProjectTeam}
                          onOpen={getTaskProjectTeam}
                          loading={loadingTeam}
                          loadingMember={loadingMember}
                        />
                      </div>
                      <Stack direction="row" alignItems="center" spacing={0.5}>
                        {(role === "team" ||
                          role === "admin" ||
                          role === "manager" ||
                          (role === "client" &&
                            (task?.creator_profile?.user_id ===
                              dispatch_get_user_profile().user_id ||
                              task?.team?.some(
                                (teamMember) =>
                                  teamMember.user_id ===
                                  dispatch_get_user_profile().user_id
                              )))) &&
                          time_track.estimated_time && (
                            <Label
                              variant="ghost"
                              color="info"
                              startIcon={
                                <Iconify icon={"ic:outline-access-time"} />
                              }
                            >
                              Estimate: {time_track.estimated_time}
                            </Label>
                          )}
                        {(role == "team" ||
                          role == "admin" ||
                          role == "manager") &&
                          task_status == 3 &&
                          time_track.actual_time && (
                            <Label
                              variant="ghost"
                              color="info"
                              startIcon={
                                <Iconify icon={"ic:outline-access-time"} />
                              }
                            >
                              Completed: {time_track.actual_time}
                            </Label>
                          )}
                        {(role == "admin" || role == "manager") &&
                          time_track.final_time && (
                            <Label
                              variant="ghost"
                              color="info"
                              startIcon={
                                <Iconify icon={"ic:outline-access-time"} />
                              }
                            >
                              Billable: {time_track.final_time}
                            </Label>
                          )}
                        {(role == "client" || role == "client_team") &&
                          time_track.final_time &&
                          task_status == 3 && (
                            <Label
                              variant="ghost"
                              color="info"
                              startIcon={
                                <Iconify icon={"ic:outline-access-time"} />
                              }
                            >
                              Completed: {time_track.final_time}
                            </Label>
                          )}
                      </Stack>
                    </Stack>
                  </Stack>
                </Grid>

                {/* Original Desktop Grid Layout (md and above) */}
                <Grid
                  sx={{
                    display: { xs: "none", md: "flex" },
                    alignItems: "center",
                  }}
                  item
                  md={2}
                  xs={6}
                >
                  <span>
                    <TaskDatePick
                      hasPortal
                      value={end_date}
                      onChange={(newDate) => onDateChange(newDate)}
                      task={task}
                      disabled={!allowDateAction()}
                    />
                  </span>
                </Grid>
                <Grid
                  sx={{
                    display: { xs: "none", md: "flex" },
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                  item
                  md={5.5}
                  xs={6}
                >
                  <Stack
                    justifyContent="center"
                    columnGap={0.7}
                    direction="row"
                    alignItems="center"
                  >
                    <Tooltip
                      title={`created by ${
                        creator_profile.first_name +
                        " " +
                        creator_profile.last_name
                      }`}
                    >
                      <div>
                        <UserAvatar
                          sx={{ width: 35, height: 35 }}
                          image={creator_profile.image}
                          alt="task creator"
                          name={
                            creator_profile.first_name +
                            " " +
                            creator_profile.last_name
                          }
                        />
                      </div>
                    </Tooltip>
                    <TaskCreatedAt date={createdAt} />
                    <PriorityPopover
                      onChange={(data) => onPriorityChange(data)}
                      allowOpen
                      value={priority}
                    />
                    <StatusPopover
                      onChange={(data) => onStatusChange(data)}
                      extraStatus={extra_status}
                      allowOpen={true}
                      excludedOptions={excludedStatusOptions()}
                      value={task_status}
                    />
                    <div className="pointer">
                      <Tooltip title="Comments">
                        <Stack
                          // Dont open comment drawer instead open task detail & scroll to comment
                          // onClick(() => onOpenComments(task))
                          onClick={(e) => {
                            onOpenDetail(task);
                            setTimeout(() => {
                              const commentsSection = document.querySelector('[data-comments-section]');
                              if (commentsSection) {
                                commentsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                              }
                            }, 2000);
                          }}
                          // -------------------------------------------------
                          direction="row"
                          alignItems="center"
                          spacing={0.1}
                        >
                          <Badge
                            badgeContent=""
                            color="error"
                            invisible={task.task_comment_unread_count == 0}
                            variant="dot"
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                          >
                            <Iconify
                              sx={{
                                height: 17,
                                width: 17,
                                color: icon_color,
                              }}
                              icon="majesticons:comment-text"
                            />
                          </Badge>
                          <Typography variant="body2">
                            {task.task_comment.length}
                          </Typography>
                        </Stack>
                      </Tooltip>
                    </div>
                    {/* ---------- Description icon  All task */}
                    {task?.task_description && (
                      <div className="pointer">
                        <Tooltip title="Description">
                          <Stack
                            onClick={() => onOpenDetail(task)}
                            direction="row"
                            alignItems="center"
                            spacing={0.1}
                          >
                            <Iconify
                              sx={{
                                height: 17,
                                width: 17,
                                color: icon_color,
                              }}
                              icon="fluent:text-description-32-filled"
                            />
                          </Stack>
                        </Tooltip>
                      </div>
                    )}

                    {/* ---------- Checklist icon All Task*/}
                    {task?.check_list.length > 0 && (
                      <div className="pointer">
                        <Tooltip title="Checklists">
                          <Stack
                            onClick={() => onOpenDetail(task)}
                            direction="row"
                            alignItems="center"
                            spacing={0.1}
                          >
                            <Iconify
                              sx={{
                                height: 17,
                                width: 17,
                                color: icon_color,
                              }}
                              icon="tabler:checkbox"
                            />
                            <Typography variant="body2">
                              {task.check_list.length}
                            </Typography>
                          </Stack>
                        </Tooltip>
                      </div>
                    )}
                    <div onClick={() => handleCopy(task)} className="pointer">
                      <Tooltip title="Copy task link">
                        <div>
                          <Iconify
                            sx={{ height: 17, width: 17, color: icon_color }}
                            icon="clarity:copy-line"
                          />
                        </div>
                      </Tooltip>
                    </div>
                  </Stack>
                </Grid>
                <Grid
                  item
                  md={4.5}
                  xs={12}
                  sx={{
                    display: { xs: "none", md: "flex" },
                    justifyContent: "flex-end",
                  }}
                >
                  <Stack
                    justifyContent="space-between"
                    columnGap={0.7}
                    direction="row"
                    alignItems="center"
                    sx={{
                      marginTop: is_mobile_view ? 0.3 : "initial",
                      paddingLeft: "40px",
                      width: "100%",
                    }}
                  >
                    {team.length === 0 ? (
                      <Avatar
                        sx={{
                          height: 29,
                          width: 29,
                        }}
                      >
                        .
                      </Avatar>
                    ) : (
                      <Box
                        sx={{
                          marginLeft: is_mobile_view ? "27px" : "initial",
                        }}
                      >
                        <TeamMembers
                          disabled={false}
                          allowOpen={true}
                          taskTeam={team}
                          projectTeam={taskTeam}
                          onChange={(
                            target_user,
                            taskTeam,
                            is_selected,
                            action
                          ) =>
                            onTeamChange(
                              target_user,
                              taskTeam,
                              is_selected,
                              action
                            )
                          }
                        />
                      </Box>
                    )}
                    <TeamPicker
                      onChange={(target_user, taskTeam, is_selected, action) =>
                        onTeamChange(target_user, taskTeam, is_selected, action)
                      }
                      allowOpen
                      taskTeam={team}
                      projectTeam={taskProjectTeam}
                      onOpen={getTaskProjectTeam}
                      loading={loadingTeam}
                      loadingMember={loadingMember}
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Stack>

        <Box
          sx={{
            display: "flex",
            overflowX: "auto",
            width: "100%",
            "&::-webkit-scrollbar": {
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: (theme) => theme.palette.divider,
              borderRadius: "10px",
            },
            mt: 1,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Stack
            direction="row"
            spacing={1}
            sx={{
              width: { xs: "max-content", lg: "100%" },
              padding: { xs: "8px 0px 12px", lg: "0px" },
              flexWrap: { xs: "nowrap", lg: "wrap" },
            }}
          >
            {task.tag_colors.map((tag) => (
              <Tooltip title={tag.name ? tag.name : ""} key={tag._id}>
                <div
                  style={{
                    display: "flex",
                    padding: "3px 5px",
                    backgroundColor: tagExpand ? "#f5f5f5" : tag.color_code,
                    borderRadius: "4px",
                    minWidth: "50px",
                    maxWidth: tagExpand ? "max-content" : "100px",
                    maxHeight: tagExpand ? "20px" : "7px",
                    minHeight: "7px",
                    fontSize: "10px",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    // color: isColorLight(tag.color_code) ? "#000" : "#fff",
                    transition: "max-height 0.3s ease",
                    cursor: "pointer",
                    borderLeft: tagExpand
                      ? `4px solid ${tag.color_code}`
                      : "none",
                  }}
                  onClick={() => setTagExpand((prev) => !prev)}
                >
                  {tagExpand && tag.name}
                </div>
              </Tooltip>
            ))}
          </Stack>
        </Box>

        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", md: "end" }}
          spacing={{ xs: 1, md: 0 }}
          sx={{ px: 1, pb: 0.5, mt: 1 }}
        >
          {/* 1. Working on task (Start) */}
          <div className="working-on-task">
            {task?.time_tracking &&
              task?.time_tracking.map(
                (time_block) =>
                  time_block.tracking_status === "start" && (
                    <div
                      className="d-flex align-items-center"
                      key={time_block.assignee.user_id}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <Iconify
                        icon="material-symbols:circle"
                        color="#3366FF"
                        fontSize="10px"
                        marginRight="5px"
                      />
                      <Typography
                        sx={{
                          fontSize: "10px",
                          color: "#637381",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span style={{ fontWeight: 600, paddingRight: "3px" }}>
                          {time_block.assignee.user_id ===
                          dispatch_get_user_profile().user_id
                            ? "You're"
                            : `${time_block.assignee.first_name} ${time_block.assignee.last_name}`}
                        </span>
                        currently working on this task
                      </Typography>
                    </div>
                  )
              )}
          </div>

          {/* 2. Checklist stats (End) */}
          <Stack direction="row" spacing={1} alignItems="center">
            {task.task_checklist_stats?.improvements_stats?.total_count > 0 && (
              <Feedback task={task} />
            )}
            {task.task_checklist_stats?.issues_stats?.total_count > 0 && (
              <IssueReport task={task} />
            )}
          </Stack>
        </Stack>
        {(currentUserRole == "admin" ||
          currentUserRole == "manager" ||
          task.creator_profile.user_id ==
            dispatch_get_user_profile().user_id) && (
          <>
            <div className="task-card-menu-btn">
              <IconButton
                sx={{ p: "3px" }}
                onClick={(e) => handleOpen(e, task)}
              >
                <Iconify
                  sx={{ color: icon_color }}
                  icon="bi:three-dots-vertical"
                />
              </IconButton>
            </div>
            <Menu
              disableEnforceFocus
              anchorEl={open}
              open={Boolean(open)}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              sx={{
                p: 0.5,
                "& .MuiMenuItem-root": {
                  typography: "body2",
                  borderRadius: 0.5,
                  mx: 0.5,
                },
              }}
            >
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  onTaskAction("del_task", task);
                  handleClose();
                }}
              >
                Delete
                <span style={{ marginLeft: "auto" }}>
                  <Iconify
                    sx={{ ml: "8px", ...menu_item_icon_size }}
                    icon="dashicons:trash"
                  />
                </span>
              </MenuItem>
            </Menu>
          </>
        )}
      </Paper>
    </React.Fragment>
  );
};

// const DefaultVariant = React.memo(DefaultVariantz);
const DisabledVariant = ({
  task,
  projectTeam,
  onOpenDetail,
  onOpenComments,
  userProfile,
  currentUserRole,
  onTaskAction,
  taskSection,
  loadingMember = {},
}) => {
  const is_mobile_view = useMediaQuery("(max-width:600px)");

  const {
    createdAt,
    end_date,
    image,
    creator_profile,
    order,
    priority,
    project_id,
  } = task;
  const { task_title, section_id, status, task_action_by, teamAssignBy } = task;
  const { task_action_id, task_comment, task_comment_count, task_description } =
    task;
  const { task_status, task_type, team, workspace_id, _id, extra_status } =
    task;
  const [open, setOpen] = useState(null);
  // const [tagExpand, setTagExpand] = useState(false);
  const { tagExpand, setTagExpand } = useAppContext();
  const { dispatch_get_user_profile } = useAppContext();
  // ---------------------------------------------------------
  /* task variants can be 'default','disabled' */
  const handleChangePriority = (_option, _index) => {
    const { value } = _option;
    console.log(_option, value);
  };
  const handleChangeStatus = (_option, _index) => {
    const { value } = _option;
    console.log(_option, value);
  };
  const excludedStatusOptions = () => {
    if (!currentUserRole) {
      return [5];
    }
    if (creator_profile.user_id === dispatch_get_user_profile().user_id) {
      return [5];
    }
    if (currentUserRole === "admin") {
      return [5];
    }
    if (currentUserRole === "manager") {
      return [5];
    }
    if (currentUserRole === "client" || currentUserRole === "client_team") {
      return [5];
    }
    if (currentUserRole === "team") {
      return [4, 5]; /* exclude verified status for team */
    }
  };
  const handleOpen = (e) => {
    setOpen(e.currentTarget);
  };
  const handleClose = () => {
    setOpen(null);
  };

  const getFormattedDate = (date) => {
    const date_format = "dd MMM yyyy hh:mm aaa";
    if (!date) {
      return "Select date";
    }
    return format(parseISO(date), date_format);
  };
  const handleCopy = (task) => {
    onTaskAction("copy_task_link", task);
  };
  // ---------------------------------------------------------
  return (
    <React.Fragment>
      <Paper
        onClick={() => {
          console.log(task, "task");
          onOpenDetail(task);
        }}
        elevation={3}
        sx={{
          width: 1,
          borderRadius: "0.3rem",
          p: 0.7,
          pt: 0.9,
          position: "relative",
          pr: 7.5,
          overflow: "hidden",
        }}
      >
        <Stack spacing={0.3}>
          <Stack {...stack_props}>
            <Checkbox
              sx={{
                mb: "auto",
                p: "4px",
                maxHeight: "128px",
                overflow: "hidden",
              }}
              disabled
              onClick={(e) => e.stopPropagation()}
            />
            <Typography
              sx={{
                color: (theme) => theme.palette.text.disabled,
                cursor: "pointer",
              }}
              role="button"
            >
              <div dangerouslySetInnerHTML={replacedText(task_title)} />
            </Typography>
          </Stack>
          <Grid container>
            <Grid
              sx={{
                paddingLeft: "9px",
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                minWidth: 0,
              }}
              item
              flexGrow={1}
            >
              <Grid id="actions" direction="row" container>
                {/* =======  Horizontal Scroller for Mobile/Tablet (below md) ======= */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: { xs: "block", md: "none" },
                    overflowX: "auto",
                    width: "100%",
                    "&::-webkit-scrollbar": {
                      height: "3px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: (theme) => theme.palette.divider,
                      borderRadius: "10px",
                    },
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={2.5}
                    sx={{
                      width: { xs: "max-content", md: "100%" },
                      padding: { xs: "0px 0px 8px 0px", md: "0px" },
                      py: 1,
                    }}
                  >
                    {/* 1. Target Date */}
                    {end_date && (
                      <Tooltip title="Target date/time">
                        <span onClick={(e) => e.stopPropagation()}>
                          <Typography
                            sx={{
                              color: (theme) => theme.palette.text.disabled,
                              fontSize: "12px",
                            }}
                          >
                            {getFormattedDate(end_date, "DD MMM YYYY")}
                          </Typography>
                        </span>
                      </Tooltip>
                    )}

                    {/* 2. Metadata Icons */}
                    <Stack
                      columnGap={0.7}
                      direction="row"
                      alignItems="center"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Tooltip
                        title={`created by ${
                          creator_profile.first_name +
                          " " +
                          creator_profile.last_name
                        }`}
                      >
                        <div>
                          <UserAvatar
                            sx={{ width: 35, height: 35 }}
                            image={creator_profile.image}
                            alt="task creator"
                            name={
                              creator_profile.first_name +
                              " " +
                              creator_profile.last_name
                            }
                          />
                        </div>
                      </Tooltip>
                      <TaskCreatedAt date={createdAt} />
                      <PriorityPopover
                        onChange={handleChangePriority}
                        allowOpen={false}
                        value={priority}
                      />
                      <StatusPopover
                        onChange={handleChangeStatus}
                        extraStatus={extra_status}
                        allowOpen={false}
                        value={task_status}
                        excludedOptions={excludedStatusOptions()}
                      />
                      <div className="pointer">
                        <Tooltip title="Comments">
                          <Stack
                            // Dont open comment drawer instead open task detail & scroll to comment
                            // onClick(() => onOpenComments(task))
                            onClick={(e) => {
                              onOpenDetail(task);

                              requestAnimationFrame(() => {
                                requestAnimationFrame(() => {
                                  const el = document.querySelector("[data-comments-section]");
                                  el?.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start",
                                  });
                                });
                              });
                            }}
                            // -------------------------------------------------
                            direction="row"
                            alignItems="center"
                            spacing={0.1}
                          >
                            <Badge
                              badgeContent=""
                              color="error"
                              invisible={task.task_comment_unread_count == 0}
                              variant="dot"
                              anchorOrigin={{
                                vertical: "top",
                                horizontal: "left",
                              }}
                            >
                              <Iconify
                                sx={{
                                  height: 17,
                                  width: 17,
                                  color: icon_color,
                                }}
                                icon="majesticons:comment-text"
                              />
                            </Badge>
                            <Typography variant="body2">
                              {task.task_comment.length}
                            </Typography>
                          </Stack>
                        </Tooltip>
                      </div>
                      {task?.task_description && (
                        <div className="pointer">
                          <Tooltip title="Description">
                            <Stack
                              onClick={() => onOpenDetail(task)}
                              direction="row"
                              alignItems="center"
                              spacing={0.1}
                            >
                              <Iconify
                                sx={{
                                  height: 17,
                                  width: 17,
                                  color: icon_color,
                                }}
                                icon="fluent:text-description-32-filled"
                              />
                            </Stack>
                          </Tooltip>
                        </div>
                      )}

                      {task?.check_list.length > 0 && (
                        <div className="pointer">
                          <Tooltip title="Checklists">
                            <Stack
                              onClick={() => onOpenDetail(task)}
                              direction="row"
                              alignItems="center"
                              spacing={0.1}
                            >
                              <Iconify
                                sx={{
                                  height: 17,
                                  width: 17,
                                  color: icon_color,
                                }}
                                icon="tabler:checkbox"
                              />
                              <Typography variant="body2">
                                {task.check_list.length}
                              </Typography>
                            </Stack>
                          </Tooltip>
                        </div>
                      )}
                      <div onClick={() => handleCopy(task)} className="pointer">
                        <Tooltip title="Copy task link">
                          <div>
                            <Iconify
                              sx={{ height: 17, width: 17, color: icon_color }}
                              icon="clarity:copy-line"
                            />
                          </div>
                        </Tooltip>
                      </div>
                    </Stack>

                    {/* 3. Team */}
                    <Stack
                      spacing={1.5}
                      direction="row"
                      alignItems="center"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Box>
                        <TeamMembers
                          onChange={(
                            target_user,
                            taskTeam,
                            is_selected,
                            action
                          ) => {}}
                          taskTeam={team}
                          projectTeam={projectTeam}
                          allowOpen={true}
                          disabled={true}
                        />
                      </Box>
                      <TeamPicker
                        allowOpen={false}
                        taskTeam={team}
                        projectTeam={projectTeam}
                        loadingMember={loadingMember}
                      />
                    </Stack>
                  </Stack>
                </Grid>

                {/* Original Desktop Grid Layout */}
                <Grid
                  sx={{
                    display: { xs: "none", md: "flex" },
                    alignItems: "center",
                  }}
                  item
                  md={2}
                  xs={6}
                >
                  {end_date && (
                    <Tooltip title="Target date/time">
                      <span onClick={(e) => e.stopPropagation()}>
                        <Typography
                          sx={{
                            color: (theme) => theme.palette.text.disabled,
                            fontSize: "12px",
                          }}
                        >
                          {getFormattedDate(end_date, "DD MMM YYYY")}
                        </Typography>
                      </span>
                    </Tooltip>
                  )}
                </Grid>
                <Grid
                  sx={{
                    display: { xs: "none", md: "flex" },
                    alignItems: "center",
                    justifyContent: "start",
                    paddingLeft: "30px",
                  }}
                  item
                  md={5.5}
                  xs={6}
                >
                  <Stack
                    justifyContent="center"
                    columnGap={0.7}
                    direction="row"
                    alignItems="center"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Tooltip
                      title={`created by ${
                        creator_profile.first_name +
                        " " +
                        creator_profile.last_name
                      }`}
                    >
                      <div>
                        <UserAvatar
                          sx={{ width: 35, height: 35 }}
                          image={creator_profile.image}
                          alt="task creator"
                          name={
                            creator_profile.first_name +
                            " " +
                            creator_profile.last_name
                          }
                        />
                      </div>
                    </Tooltip>
                    <TaskCreatedAt date={createdAt} />
                    <PriorityPopover
                      onChange={handleChangePriority}
                      allowOpen={false}
                      value={priority}
                    />
                    <StatusPopover
                      onChange={handleChangeStatus}
                      extraStatus={extra_status}
                      allowOpen={false}
                      value={task_status}
                      excludedOptions={excludedStatusOptions()}
                    />
                    <div className="pointer">
                      <Tooltip title="Comments">
                        <Stack
                          // Dont open comment drawer instead open task detail & scroll to comment
                          // onClick(() => onOpenComments(task))
                          onClick={(e) => {
                            onOpenDetail(task);
                            setTimeout(() => {
                              const commentsSection = document.querySelector('[data-comments-section]');
                              if (commentsSection) {
                                commentsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                              }
                            }, 2000);
                          }}
                          // -------------------------------------------------
                          direction="row"
                          alignItems="center"
                          spacing={0.1}
                        >
                          <Badge
                            badgeContent=""
                            color="error"
                            invisible={task.task_comment_unread_count == 0}
                            variant="dot"
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                          >
                            <Iconify
                              sx={{
                                height: 17,
                                width: 17,
                                color: icon_color,
                              }}
                              icon="majesticons:comment-text"
                            />
                          </Badge>
                          <Typography variant="body2">
                            {task.task_comment.length}
                          </Typography>
                        </Stack>
                      </Tooltip>
                    </div>
                    {task?.task_description && (
                      <div className="pointer">
                        <Tooltip title="Description">
                          <Stack
                            onClick={() => onOpenDetail(task)}
                            direction="row"
                            alignItems="center"
                            spacing={0.1}
                          >
                            <Iconify
                              sx={{
                                height: 17,
                                width: 17,
                                color: icon_color,
                              }}
                              icon="fluent:text-description-32-filled"
                            />
                          </Stack>
                        </Tooltip>
                      </div>
                    )}

                    {task?.check_list.length > 0 && (
                      <div className="pointer">
                        <Tooltip title="Checklists">
                          <Stack
                            onClick={() => onOpenDetail(task)}
                            direction="row"
                            alignItems="center"
                            spacing={0.1}
                          >
                            <Iconify
                              sx={{
                                height: 17,
                                width: 17,
                                color: icon_color,
                              }}
                              icon="tabler:checkbox"
                            />
                            <Typography variant="body2">
                              {task.check_list.length}
                            </Typography>
                          </Stack>
                        </Tooltip>
                      </div>
                    )}
                    <div onClick={() => handleCopy(task)} className="pointer">
                      <Tooltip title="Copy task link">
                        <div>
                          <Iconify
                            sx={{ height: 17, width: 17, color: icon_color }}
                            icon="clarity:copy-line"
                          />
                        </div>
                      </Tooltip>
                    </div>
                  </Stack>
                </Grid>
                <Grid
                  item
                  md={4.5}
                  xs={12}
                  sx={{
                    display: { xs: "none", md: "flex" },
                    justifyContent: "flex-end",
                  }}
                >
                  <Stack
                    justifyContent="space-between"
                    columnGap={0.7}
                    direction="row"
                    alignItems="center"
                    sx={{
                      marginTop: is_mobile_view ? 0.3 : "initial",
                      paddingLeft: "40px",
                      width: "100%",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Box
                      sx={{
                        marginLeft: is_mobile_view ? "27px" : "initial",
                      }}
                    >
                      <TeamMembers
                        onChange={(
                          target_user,
                          taskTeam,
                          is_selected,
                          action
                        ) => {}}
                        taskTeam={team}
                        projectTeam={projectTeam}
                        allowOpen={true}
                        disabled={true}
                      />
                    </Box>
                    <TeamPicker
                      allowOpen={false}
                      taskTeam={team}
                      projectTeam={projectTeam}
                      loadingMember={loadingMember}
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Stack>

        <Box
          sx={{
            display: "flex",
            overflowX: "auto",
            width: "100%",
            "&::-webkit-scrollbar": {
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: (theme) => theme.palette.divider,
              borderRadius: "10px",
            },
            mt: 1,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Stack
            direction="row"
            spacing={1}
            sx={{
              width: { xs: "max-content", lg: "100%" },
              padding: { xs: "8px 0px 12px", lg: "0px" },
              flexWrap: { xs: "nowrap", lg: "wrap" },
            }}
          >
            {task.tag_colors.map((tag) => (
              <Tooltip title={tag.name ? tag.name : ""} key={tag._id}>
                <div
                  style={{
                    display: "flex",
                    padding: "3px 5px",
                    backgroundColor: tagExpand ? "#f5f5f5" : tag.color_code,
                    borderRadius: "4px",
                    minWidth: "50px",
                    maxWidth: tagExpand ? "max-content" : "100px",
                    maxHeight: tagExpand ? "20px" : "7px",
                    minHeight: "7px",
                    fontSize: "10px",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    // color: isColorLight(tag.color_code) ? "#000" : "#fff",
                    transition: "max-height 0.3s ease",
                    cursor: "pointer",
                    borderLeft: tagExpand
                      ? `4px solid ${tag.color_code}`
                      : "none",
                  }}
                  onClick={() => setTagExpand((prev) => !prev)}
                >
                  {tagExpand && tag.name}
                </div>
              </Tooltip>
            ))}
          </Stack>
        </Box>
        <div onClick={(e) => e.stopPropagation()}>
          <Tooltip title="not allowed">
            <div className="task-card-menu-btn">
              <IconButton disabled>
                <Iconify
                  sx={{ color: (theme) => theme.palette.text.disabled }}
                  icon="fluent:more-vertical-16-filled"
                />
              </IconButton>
            </div>
          </Tooltip>
          <Menu
            disableEnforceFocus
            anchorEl={open}
            open={Boolean(open)}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            sx={{
              p: 0.5,
              mt: 1,
              "& .MuiMenuItem-root": {
                typography: "body2",
                borderRadius: 0.5,
                mx: 0.5,
              },
            }}
          >
            <MenuItem>Move to</MenuItem>
            <MenuItem>Delete</MenuItem>
          </Menu>
        </div>
      </Paper>
    </React.Fragment>
  );
};

const DashboardVariant = ({ task, onOpenDetail, onTaskAction }) => {
  const is_mobile_view = useMediaQuery("(max-width:600px)");

  const {
    createdAt,
    end_date,
    image,
    creator_profile,
    order,
    priority,
    project_id,
    extra_status,
  } = task;
  const { task_title, section_id, status, task_action_by, teamAssignBy } = task;
  const { task_action_id, task_comment, task_comment_count, task_description } =
    task;
  const { task_status, task_type, team, project_title, workspace_id, _id } =
    task;
  const [open, setOpen] = useState(null);
  const { dispatch_get_user_profile } = useAppContext();
  const userProfile = dispatch_get_user_profile();
  // ---------------------------------------------------------
  /* task variants can be 'default','disabled' */
  const handleChangePriority = (_option, _index) => {
    const { value } = _option;
    console.log(_option, value);
    const data = {
      task: task,
      new_priority: value,
    };
    onTaskAction("priority_change", data);
  };
  const handleChangeStatus = (_option, _index) => {
    const { value } = _option;
    console.log(_option, value);
    const data = {
      task: task,
      new_status: value,
    };
    onTaskAction("status_change", data);
  };

  const getFormattedDate = (date) => {
    if (!date) {
      return "Select date";
    }
    return get_zone_date(date, "DD MMM YYYY");
  };
  const handleNav = (_task) => {
    onOpenDetail(_task);
  };
  const handleCopy = (task) => {
    onTaskAction("copy_task_link", task);
  };
  const onStatusCheckChange = (e) => {
    let checked = e.target.checked;
    const data = {
      checked: checked,
      task: task,
    };
    onTaskAction("status_check", data);
  };

  const isChecked = () => {
    if (String(task_status) === "3") {
      return true;
    }

    if (String(task_status) === "4") {
      return true;
    }
    return false;
  };
  const onTargetDateTimeChange = (new_date_time) => {
    console.log(new_date_time, "new-date");
    const data = {
      new_time: new_date_time,
      task: task,
    };
    onTaskAction("target_date_time_change", data);
  };
  // ---------------------------------------------------------
  return (
    <React.Fragment>
      <Paper
        id={task._id}
        onClick={() => console.log(task, "task")}
        elevation={3}
        sx={{
          width: 1,
          borderRadius: "0.3rem",
          p: 0.7,
          pt: 0.9,
          position: "relative",
          pr: 7.5,
          overflow: "hidden",
        }}
      >
        <Stack spacing={0.3}>
          <Stack {...stack_props}>
            <Checkbox
              value={task_status}
              onChange={onStatusCheckChange}
              checked={isChecked()}
              sx={{
                mb: "auto",
                p: "4px",
                maxHeight: "128px",
                overflow: "hidden",
              }}
            />
            <Typography
              onClick={() => handleNav(task)}
              sx={{
                cursor: "pointer",
              }}
              role="button"
            >
              <div dangerouslySetInnerHTML={replacedText(task_title)} />
            </Typography>
          </Stack>
          <Grid container>
            <Grid
              sx={{
                paddingLeft: "9px",
                display: "flex",
                alignItems: "center",
              }}
              item
              flexGrow={1}
            >
              <Grid id="actions" direction="row" container>
                {/* =======  Horizontal Scroller for Mobile/Tablet (below md) ======= */}

                <Grid
                  item
                  xs={12}
                  sx={{
                    display: { xs: "block", md: "none" },
                    overflowX: "auto",
                    width: "100%",
                    "&::-webkit-scrollbar": {
                      height: "3px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: (theme) => theme.palette.divider,
                      borderRadius: "10px",
                    },
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={2.5}
                    sx={{
                      width: { xs: "max-content", md: "100%" },
                      padding: { xs: "0px 0px 8px 0px", md: "0px" },
                      py: 1,
                    }}
                  >
                    <span>
                      <TaskDatePick
                        value={end_date}
                        hasPortal
                        onChange={onTargetDateTimeChange}
                        task={task}
                      />
                    </span>
                    <Stack
                      columnGap={0.7}
                      direction="row"
                      alignItems="center"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Tooltip
                        title={`created by ${
                          creator_profile.first_name +
                          " " +
                          creator_profile.last_name
                        }`}
                      >
                        <div>
                          <UserAvatar
                            sx={{ width: 35, height: 35 }}
                            image={creator_profile.image}
                            alt="task creator"
                            name={
                              creator_profile.first_name +
                              " " +
                              creator_profile.last_name
                            }
                          />
                        </div>
                      </Tooltip>
                      <TaskCreatedAt date={createdAt} />
                      <PriorityPopover
                        onChange={handleChangePriority}
                        allowOpen={true}
                        value={priority}
                      />
                      <StatusPopover
                        onChange={handleChangeStatus}
                        extraStatus={extra_status}
                        allowOpen={true}
                        value={task_status}
                        excludedOptions={[5]}
                      />
                      <div onClick={() => handleCopy(task)} className="pointer">
                        <Tooltip title="Copy task link">
                          <div>
                            <Iconify
                              sx={{ height: 17, width: 17, color: icon_color }}
                              icon="clarity:copy-line"
                            />
                          </div>
                        </Tooltip>
                      </div>
                    </Stack>
                    <Stack direction="row" alignItems="center">
                      <Tooltip title="Project name">
                        <Typography
                          onClick={() => handleNav(task)}
                          noWrap
                          className="project-name-btn"
                        >
                          {task.project.name}
                        </Typography>
                      </Tooltip>
                    </Stack>
                  </Stack>
                </Grid>

                {/* Desktop Grid Layout */}
                <Grid
                  sx={{
                    display: { xs: "none", md: "flex" },
                    alignItems: "center",
                  }}
                  item
                  md={2}
                  xs={6}
                >
                  <span>
                    <TaskDatePick
                      value={end_date}
                      hasPortal
                      onChange={onTargetDateTimeChange}
                      task={task}
                    />
                  </span>
                </Grid>

                <Grid
                  sx={{
                    display: { xs: "none", lg: "flex" },
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  item
                  md={5.5}
                  xs={6}
                >
                  <Stack
                    justifyContent="center"
                    columnGap={0.7}
                    direction="row"
                    alignItems="center"
                  >
                    <Tooltip
                      title={`created by ${
                        creator_profile.first_name +
                        " " +
                        creator_profile.last_name
                      }`}
                    >
                      <div>
                        <UserAvatar
                          sx={{ width: 35, height: 35 }}
                          image={creator_profile.image}
                          alt="task creator"
                          name={
                            creator_profile.first_name +
                            " " +
                            creator_profile.last_name
                          }
                        />
                      </div>
                    </Tooltip>
                    <TaskCreatedAt date={createdAt} />
                    <PriorityPopover
                      onChange={handleChangePriority}
                      allowOpen={true}
                      value={priority}
                    />
                    <StatusPopover
                      onChange={handleChangeStatus}
                      extraStatus={extra_status}
                      allowOpen={true}
                      value={task_status}
                      excludedOptions={[5]}
                    />

                    <div onClick={() => handleCopy(task)} className="pointer">
                      <Tooltip title="Copy task link">
                        <div>
                          <Iconify
                            sx={{ height: 17, width: 17, color: icon_color }}
                            icon="clarity:copy-line"
                          />
                        </div>
                      </Tooltip>
                    </div>
                  </Stack>
                </Grid>

                <Grid
                  item
                  md={4.5}
                  xs={12}
                  sx={{
                    display: { xs: "none", md: "flex" },
                    justifyContent: "flex-end",
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ width: "100%" }}
                  >
                    <Tooltip title="Project name">
                      <Typography
                        onClick={() => handleNav(task)}
                        noWrap
                        className="project-name-btn"
                      >
                        {task.project.name}
                      </Typography>
                    </Tooltip>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Stack>
      </Paper>
    </React.Fragment>
  );
};

export default TaskCard;
TaskCard.propTypes = {
  task: PropTypes.object.isRequired,
  variant: PropTypes.oneOf(["default", "disabled", "dashboard", "allTasks"])
    .isRequired,
};
